export default __webpack_public_path__ + "static/media/logo-us-shopdisney.6e563cfd.svg";